import axios from 'axios'
import qs from 'querystring'


const API_BASE_URL = process.env.VUE_APP_API_URL;

export default {
    searchPlaceByKeyword(keyword) {
        return axios.get(`${API_BASE_URL}/api/search/places`, {
            params: {
                keyword,
            }
        })
    },

    queryPrice(data) {
        return axios.post(
            `${API_BASE_URL}/api/search/price`,
            qs.stringify(data), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
            }
        )
    }
}
